function handleMenuStates() {
  const links = document.querySelectorAll('.js-menu-item-container');
  if (links.length < 1) return;

  links.forEach(link => {
    // Add class when menu opens
    link.addEventListener('mouseenter', () => {
      document.body.classList.add('megamenu-open');
    });

    // Remove class when menu closes
    link.addEventListener('mouseleave', e => {
      const activeEl = document.activeElement;
      
      if (activeEl && activeEl.closest('.js-list-menu')) {
        activeEl.blur();
      }

      // Delay check to allow focus transition
      setTimeout(() => {
        if (!document.querySelector('.js-menu-item-container:hover')) {
          document.body.classList.remove('megamenu-open');
        }
      }, 50);
    });
  });
}

handleMenuStates();

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".list-menu li").forEach(li => {
    if (li.querySelector(".mega-menu__column-content")) {
      li.classList.add("column-content-mega-menu");
    }
  });
});